import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'
import { Spin } from 'view-design'

const state = {
  ...restful.states('dashboard'),
  inforCardData: {},
  pieData: [],
  item_total: 0,
  weekly: {},
  daily: {},
  statement_sale_data: {},
  statement_product_data: {}
}

const getters = {
  ...restful.getters('dashboard'),
  pieData: (state) => state.pieData,
  inforCardData: (state) => state.inforCardData,
  item_total: (state) => state.item_total,
  statement_sale_summary: (state) => state.statement_sale_data.summary,
  statement_product_summary: (state) => state.statement_product_data.summary,
  statement_sale_table_data: (state) => {
    return {
      frontSaleDetail: state.statement_sale_data?.front_order_detail?.sale_detail,
      frontDiscountDetail: state.statement_sale_data?.front_order_detail?.discount_detail,
      frontRevenueDetail: state.statement_sale_data?.front_order_detail?.revenue_detail,
      wechatSaleDetail: state.statement_sale_data?.wechat_order_detail?.sale_detail,
      wechatDiscountDetail: state.statement_sale_data?.wechat_order_detail?.discount_detail
    }
  },
  statement_product_table_data: (state) => {
    return {
      frontProductDetail: state.statement_product_data?.front_order_detail?.product_detail,
      frontCateogryDetail: state.statement_product_data?.front_order_detail?.cateogry_detail,
      wechatProductDetail: state.statement_product_data?.wechat_order_detail?.product_detail,
      wechatCateogryDetail: state.statement_product_data?.wechat_order_detail?.cateogry_detail
    }
  }
}

const actions = {
  ...restful.actions('dashboards'),
  async dashboardCount ({ commit }) {
    const response = await axios.get('dashboards')
    const result = [
      {
        title: i18n.t('store_modules_dashboard_1321'),
        icon: 'ios-reorder',
        count: response.data.today,
        color: '#2d8cf0'
      },
      {
        title: i18n.t('store_modules_dashboard_1322'),
        icon: 'md-locate',
        count: response.data.fresh_customers,
        color: '#19be6b'
      },
      {
        title: i18n.t('store_modules_dashboard_1323'),
        icon: 'md-map',
        count: response.data.fresh_customer_charges,
        color: '#9A66E4'
      },
      {
        title: i18n.t('store_modules_dashboard_1324'),
        icon: 'md-menu',
        count: response.data.fresh_products,
        color: '#ff9900'
      },
      {
        title: i18n.t('store_modules_dashboard_1325'),
        icon: 'md-reorder',
        count: response.data.total_orders,
        color: '#E46CBB'
      },
      {
        title: i18n.t('store_modules_dashboard_1326'),
        icon: 'md-chatbubbles',
        count: response.data.fresh_suppliers,
        color: '#E46CBB'
      },
      {
        title: i18n.t('store_modules_dashboard_1327'),
        icon: 'md-map',
        count: response.data.fresh_messages,
        color: '#9A66E4'
      }
    ]
    commit('pieData', response.data.orders)
    commit('inforCardData', result)
    commit('setWeekly', response.data.last_7_days_orders)
    commit('setDaily', response.data.today_24_hours_orders)
    commit('item_total', response.data.item_total)
  },
  async getStatementSale ({ commit }, params) {
    Spin.show()
    const response = await axios.get('dashboards/statement_sale', { params })
    commit('statement_sale_data', response.data)
    Spin.hide()
  },
  async getStatementProduct ({ commit }, params) {
    Spin.show()
    const response = await axios.get('dashboards/statement_product', { params })
    commit('statement_product_data', response.data)
    Spin.hide()
  },
}
const mutations = {
  ...restful.mutations('dashboard'),
  pieData (state, pieData) {
    state.pieData = pieData
  },
  setWeekly (state, barData) {
    state.weekly = barData
  },
  setDaily (state, barData) {
    state.daily = barData
  },
  inforCardData (state, inforCardData) {
    state.inforCardData = inforCardData
  },
  item_total (state, item_total) {
    state.item_total = item_total
  },
  statement_sale_data (state, data) {
    state.statement_sale_data = data
  },
  statement_product_data (state, data) {
    state.statement_product_data = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
